export const ContainerOverviewSlotName = {
  Content: 'container-overview-content',
  Navigation: 'container-overview-navigation',
  Footer: 'container-overview-footer',
};

export default {
  ContainerOverviewSlotName,
};
